// ================================================================================
// comparison.js
// 比較用のスクリプトファイル
// ================================================================================

// 検索ページの比較
// --------------------------------------------------------------- //

window.addEventListener('pageshow', () => {

	const comparisonCheck = document.querySelectorAll('.js-comparison-check')
	const comparisonObj = document.getElementById('js-switch-comparison');
	const comparisonTarget = document.getElementById('js-comparison-contents');
	const comparisonLink = document.getElementById('js-comparison-button');
	let comparisonUrl;
	let urlSlug = '/comparison'
	if ( document.getElementById('js-comparison-button') ) {
		comparisonUrl = comparisonLink.getAttribute('href');
	}

	const comarisonClose = document.querySelectorAll('.js-switch-comparison-close');

	let comparisonArray = [];

	for ( let i = 0; i < comparisonCheck.length; i++ ) {

		let checkObj = comparisonCheck[i].closest('.switch-item')
		let checkId = checkObj.dataset.id;

		if ( comparisonCheck[i].checked === true ) {
			if ( comparisonArray.indexOf(1) == -1 ) {
				comparisonArray.push(checkId);
			}
			comparisonParse( comparisonArray );
			checkControlFunc ( comparisonArray )

		} else {
//			let comparisonArrayIndex = comparisonArray.indexOf(checkId);
//			comparisonArray.splice(comparisonArrayIndex, 1)
//			comparisonParse( comparisonArray );
//			checkControlFunc ( comparisonArray )

		}

		comparisonCheck[i].addEventListener('click', () => {
			if ( comparisonCheck[i].checked === true ) {
				if ( comparisonArray.indexOf(1) == -1 ) {
					comparisonArray.push(checkId);
				}
				comparisonParse( comparisonArray );
				checkControlFunc ( comparisonArray )

			} else {
				let comparisonArrayIndex = comparisonArray.indexOf(checkId);
				comparisonArray.splice(comparisonArrayIndex, 1)
				comparisonParse( comparisonArray );
				checkControlFunc ( comparisonArray )

			}
		});

	}

	function checkControlFunc ( $array ) {
		if ( $array.length > 2 ) {
			for ( let i = 0; i < comparisonCheck.length; i++ ) {
				if ( comparisonCheck[i].checked === false ) {
					comparisonCheck[i].disabled = true;
				}
			}
		} else {
			for ( let i = 0; i < comparisonCheck.length; i++ ) {
				comparisonCheck[i].disabled = false;
			}
		}
	}


	document.addEventListener('click', function(e) {
		if (event.target && event.target.classList.contains('switch-comparison-item__close') ) {
			let removeId = event.target.dataset.target;

			// チェックを外す
			document.querySelector('article[data-id="' + removeId + '"] .js-comparison-check').checked = false

			// 配列から削除
			let arrayIndex = comparisonArray.indexOf(removeId);
			if (arrayIndex > -1) {
				comparisonArray.splice(arrayIndex, 1);
			}

			comparisonParse( comparisonArray )
			checkControlFunc ( comparisonArray )
		}

		return false
	});


	function comparisonParse( $array ) {
		if ( $array.length ) {

			let insertTags = '';
			let url = '';

			$array.forEach( (value, index) => {

				let $id = value;
				let $title, $series, $image;

				if ( document.querySelector('article[data-id="' + $id + '"] .switch-item__title a') ) {
					$title = document.querySelector('article[data-id="' + $id + '"] .switch-item__title a').textContent
				} else {
					$title = '';
				}
				if ( document.querySelector('article[data-id="' + $id + '"] .switch-item__series a') ) {
					$series = document.querySelector('article[data-id="' + $id + '"] .switch-item__series a').textContent
				} else {
					$series = '';
				}
				if ( document.querySelector('article[data-id="' + $id + '"] .switch-item-content__thumbnail img') ) {
					$image = document.querySelector('article[data-id="' + $id + '"] .switch-item-content__thumbnail img').getAttribute('src')
				}

				insertTags += '<div class="switch-comparison__stack js-comparison-stack is-active">';
					insertTags += '<div class="switch-comparison-item">';
						if ( $image ) {
							insertTags += '<p class="switch-comparison-item__thumbnail">';
								insertTags += '<img src="' + $image + '" alt="">';
							insertTags += '</p>';
						}
						insertTags += '<div class="switch-comparison-item__container">';
							insertTags += '<p class="switch-comparison-item__series">';
								insertTags += $series;
							insertTags += '</p>';
							insertTags += '<p class="switch-comparison-item__title">';
								insertTags += $title;
							insertTags += '</p>';
						insertTags += '</div>';
						insertTags += '<a href="javascript:void(0);" class="switch-comparison-item__close js-switch-comparison-close" data-target="' + $id + '"></a>';
					insertTags += '</div>';
				insertTags += '</div>';

				// url の生成
				if ( index == ( $array.length - 1 ) ) {
					url += 'id[]=' + $id;
				} else {
					url += 'id[]=' + $id + '&';
				}

			} );

			if ( $array.length == 1 ) {
				insertTags += '<div class="switch-comparison__stack js-comparison-stack"></div>';
				insertTags += '<div class="switch-comparison__stack js-comparison-stack"></div>';
			} else if ( $array.length == 2 ) {
				insertTags += '<div class="switch-comparison__stack js-comparison-stack"></div>';
			}

			comparisonObj.classList.add('is-visible');

			comparisonTarget.innerHTML = insertTags
			comparisonLink.href = urlSlug + '/?' + url

		} else {

			comparisonTarget.innerHTML = '<div class="switch-comparison__stack js-comparison-stack"></div><div class="switch-comparison__stack js-comparison-stack"></div><div class="switch-comparison__stack js-comparison-stack"></div>';

			comparisonLink.href = comparisonUrl
			comparisonObj.classList.remove('is-visible');
		}
	}

} );

//for ( let i = 0; i < comarisonClose.length; i++ ) {
//			comarisonClose[i].addEventListener('click', () => {
//				console.log("a");
//			});
//		}
//
//	function comparisonCloseClick() {
////		for ( let i = 0; i < comarisonClose.length; i++ ) {
////			comarisonClose[i].addEventListener('click', () => {
////				console.log("a");
////			});
////		}
//		console.log("a");
//		return false;
//	}


document.addEventListener('DOMContentLoaded', () => {

	// 比較ページでの thead 固定
	// --------------------------------------------------------------- //
	if ( document.getElementById('js-comparison-header') ) {
		let heightTarget = document.getElementById('js-comparison-header')

		let startPost = heightTarget.getBoundingClientRect().top + window.pageYOffset

		let endPost = heightTarget.getBoundingClientRect().top + window.pageYOffset + document.getElementById('js-comparison-table').offsetHeight - heightTarget.offsetHeight

		window.onscroll = function(e) {
			let offset = window.pageYOffset

			if ( offset > startPost && offset < endPost ) {
				heightTarget.classList.add('is-fixed')
				heightTarget.classList.remove('is-absolute')
			} else if ( offset > endPost  ) {
				heightTarget.classList.add('is-absolute')
			} else {
				heightTarget.classList.remove('is-fixed')
				heightTarget.classList.remove('is-absolute')
			}

		}
	}

} );

